import { strIsNullOrEmpty } from '@fox/atoms';
import { sanitize } from 'dompurify';
import { useImporterContext } from './importer-context';

export function GuideLines() {
	const { guideLineText } = useImporterContext();
	if (strIsNullOrEmpty(guideLineText)) return <></>;
	return <div dangerouslySetInnerHTML={{ __html: sanitize(guideLineText) }} />;
}
